import { withScalars } from "apollo-link-scalars";
import introspectionResult from "@graphql-generated/client-schema.json";
import { buildClientSchema, IntrospectionQuery } from "graphql";
import { DateScalar } from "@config/apollo/scalars/date-scalar";
import { PermissionScalar } from "@config/apollo/scalars/permissions-scalar";

const schema = buildClientSchema(introspectionResult as unknown as IntrospectionQuery);

export const customScalarsLink = withScalars({
    schema,
    typesMap: {
        DateTime: DateScalar,
        MapStringPermission: PermissionScalar,
    },
});
